'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable max-len */
exports.default = {
  default: {},
  eukdlx: {
    default: {
      'updateLoginPath': function updateLoginPath(_ref) {
        var country = _ref.country,
            language = _ref.language,
            brand = _ref.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      }
    },
    'en-GB': {}
  },
  eukexp: {
    default: {
      'termsConditionsPath': function termsConditionsPath(_ref2) {
        var language = _ref2.language;
        return '/' + language + '/terms';
      },
      'termsOfUsePath': function termsOfUsePath(_ref3) {
        var language = _ref3.language;
        return '/' + language + '/terms';
      },
      'cookiePolicyPath': function cookiePolicyPath(_ref4) {
        var language = _ref4.language;
        return '/' + language + '/cookies';
      },
      'updateLoginPath': function updateLoginPath(_ref5) {
        var country = _ref5.country,
            language = _ref5.language;
        return '/bin/api/login-shop?page=/content/akzonobel-painters/duluxtrade/' + country + '/' + language;
      }
    }
  },
  enlflx: {
    default: {
      'updateLoginPath': function updateLoginPath(_ref6) {
        var country = _ref6.country,
            language = _ref6.language,
            brand = _ref6.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      }
    }
  },
  ebelev: {
    default: {
      'updateLoginPath': function updateLoginPath(_ref7) {
        var country = _ref7.country,
            language = _ref7.language,
            brand = _ref7.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      },
      'forgotPasswordPath': function forgotPasswordPath(_ref8) {
        var language = _ref8.language;
        return '/' + language + '/forgot-password';
      }
    },
    'fr-BE': {
      'updateLoginPath': function updateLoginPath(_ref9) {
        var country = _ref9.country,
            language = _ref9.language,
            brand = _ref9.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      },
      'forgotPasswordPath': function forgotPasswordPath(_ref10) {
        var language = _ref10.language;
        return '/' + language + '/mot-de-passe-oubli\xE9';
      }
    }
  },
  eiedlx: {
    default: {
      'updateLoginPath': function updateLoginPath(_ref11) {
        var country = _ref11.country,
            language = _ref11.language,
            brand = _ref11.brand;
        return '/bin/api/login-shop?page=/content/akzonobel-flourish/' + brand + '/' + country + '/' + language;
      }
    }
  },
  ebewdc: {
    default: {
      'privacyPolicyPath': function privacyPolicyPath(_ref12) {
        var language = _ref12.language;
        return '/' + language + '/privacyverklaring';
      },
      'termsConditionsPath': function termsConditionsPath(_ref13) {
        var language = _ref13.language;
        return '/' + language + '/wettelijke-bepalingen';
      },
      'cookies': function cookies(_ref14) {
        var language = _ref14.language;
        return '/' + language + '/cookies';
      }
    },
    'fr-BE': {
      "privacyPolicyPath": function privacyPolicyPath(_ref15) {
        var language = _ref15.language;
        return '/' + language + '/declaration-confidentialite';
      },
      "termsConditionsPath": function termsConditionsPath(_ref16) {
        var language = _ref16.language;
        return '/' + language + '/mentions-legales';
      },
      'cookies': function cookies(_ref17) {
        var language = _ref17.language;
        return '/' + language + '/cookies';
      }
    }
  },
  eukher: {
    default: {
      'productsPath': function productsPath(_ref18) {
        var language = _ref18.language;
        return '/' + language + '/our-products';
      }
    }
  },
  enlwdc: {
    default: {
      'privacyPolicyPath': function privacyPolicyPath(_ref19) {
        var language = _ref19.language;
        return '/' + language + '/privacybeleid';
      },
      'termsConditionsPath': function termsConditionsPath(_ref20) {
        var language = _ref20.language;
        return '/' + language + '/gebruiksvoorwaarden';
      },
      'salesConditionsPath': function salesConditionsPath(_ref21) {
        var language = _ref21.language;
        return '/' + language + '/verkoopvoorwaarden';
      },
      'cookies': function cookies(_ref22) {
        var language = _ref22.language;
        return '/' + language + '/cookiebeleid';
      },
      'productsPath': function productsPath(_ref23) {
        var language = _ref23.language;
        return '/' + language + '/productoverzicht';
      }
    }
  },
  edeexp: {
    default: {
      'privacyPolicyPath': function privacyPolicyPath(_ref24) {
        var language = _ref24.language;
        return '/' + language + '/datenschutzerkl\xE4rung';
      },
      'termsConditionsPath': function termsConditionsPath(_ref25) {
        var language = _ref25.language;
        return '/' + language + '/allgemeine-nutzungsbedingungen';
      },
      'salesConditionsPath': function salesConditionsPath(_ref26) {
        var language = _ref26.language;
        return '/' + language + '/allgemeine-nutzungsbedingungen';
      },
      'cookies': function cookies(_ref27) {
        var language = _ref27.language;
        return '/' + language + '/cookies';
      },
      'productsPath': function productsPath(_ref28) {
        var language = _ref28.language;
        return '/' + language + '/produkte';
      },
      'coloursPath': function coloursPath(_ref29) {
        var language = _ref29.language;
        return '/' + language + '/produkte';
      }
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./config/localisedPathOverrides.js
// module id = 2237
// module chunks = 0